export default __webpack_public_path__ + "static/media/white-logo.5f533954.svg";